
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/cv/search/[[...pageNr]]",
      function () {
        return require("private-next-pages/[locale]/cv/search/[[...pageNr]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/cv/search/[[...pageNr]]"])
      });
    }
  